/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import { Container, IconButton, Card, CardContent } from "@material-ui/core";
import {
  Dialog as MuiDialog,
  DialogActions as MuiDialogActions,
  DialogContent as MuiDialogContent,
  Divider as MuiDivider,
  Typography as MuiTypography,
} from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import PageTitle from "../../../components/pageTitle/PageTitle";
import CircularProgress from "@mui/material/CircularProgress";
import { getInvoice, getSettings } from "../../../services/apiservices/settings";
import { getAllEmployee } from "../../../services/apiservices/employee";
import ThemeTable from "../../../components/Table/ThemeTable";
import moment from "moment";
import AuthContext from "../../../hooks/authContext";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { RefundSubscriptionAmount } from "../../../components/DialogComponent/SupplyDataDialog";
import { packageAccess } from "../../../services/helpers";
import {
  CancelStripeSubscription,
  createStripeLink,
  detachPaymentMethod,
  getChargesData,
  getCustomerPaymentMethods,
  getFreshInvoiceData,
  getPendingPaymentVerificationByUser,
  updateDefaultPaymentMethod,
} from "../../../services/apiservices/users";
import CommonContext from "../../../hooks/commonContext";
import { Tabs, TabsContent, TabsTrigger } from "../../../components/Tabs/Tabs";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import StorageOutlinedIcon from "@mui/icons-material/StorageOutlined";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import styles from "../users.module.scss";
import { useMediaQuery } from "@mui/material";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import CancelStep1 from "./CancelStep1";
import CancelStep2 from "./CancelStep2";
import { CardHeader, CardTitle } from "../../../components/ui/card";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../components/ui/dialog";
import { Landmark, Plus, Trash } from "lucide-react";
import { Elements } from "@stripe/react-stripe-js";
import { STRIPE_PUBLISHABLE_KEY } from "../../../services/config";
import { useToast } from "../../../hooks/useToast";
import CardForm from "./CardForm";
import { Button } from "../../../components/ui/button";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "../../../components/ui/alertDialog";
import { BankAccountVerification } from "../../Accounts/Upgrade/ACHverification";

const formatStorage = (bytes) => {
  if (bytes < 1024 * 1024) {
    return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
  }
  if (bytes >= 1 * 1024 * 1024 * 1024 * 1024) {
    return `${(bytes / (1 * 1024 * 1024 * 1024 * 1024)).toFixed(2)} TB`;
  }
  if (bytes >= 1024 * 1024 * 1024) {
    return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
  }
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
};

const StorageUsage = ({ totalStorage, usedStorage }) => {
  const usedPercentage = (usedStorage / totalStorage) * 100;

  return (
    <div className="storage-container d-flex dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0">
      <div className={styles.billingIcon}>
        <StorageOutlinedIcon fontSize="small" className={styles.icon} />
      </div>
      <div className="w-100 ml-10">
        <div className="storage-info">
          <span>{formatStorage(usedStorage)} Used</span>
          <span>{formatStorage(totalStorage)} Total</span>
        </div>
        <div className="storage-bar">
          <div
            className="storage-fill"
            style={{ width: `${usedPercentage}%` }}
          ></div>
        </div>
      </div>
    </div>
  );
};

const CompanySubscription = () => {
  const [searchTerm, setsearchTerm] = React.useState("");
  const [companyData, setCompanyData] = React.useState();
  const [isLoading, setIsLoading] = React.useState(false);
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [cancelDialogOpen, setCancelDialogOpen] = React.useState(false);
  const [refundOpen, setRefundOpen] = React.useState(false);
  const [displayStep, setDisplayStep] = React.useState(0);
  const [selectedOption, setSelectedOption] = React.useState();
  const [feedBack, setFeedBack] = React.useState("");
  const [updateDialogOpen, setUpdateDialogOpen] = React.useState(false);
  const [loadingInvoiceId, setLoadingInvoiceId] =  React.useState(null);
  const [isAddDialogOpen, setIsAddDialogOpen] = React.useState(false);
  const [name, setName] = React.useState("");
  const [data, setData] = React.useState();
  const [prices, setPrices] = React.useState();
  const [cardDetails, setCardDetails] = React.useState();
  const [activeTab, setActiveTab] = React.useState("subscription");
  const auth = useContext(AuthContext);
  const commonContext = useContext(CommonContext);
  const companyId =
    auth?.userProfile?.role === "companyUser"
      ? auth?.userProfile?.id
      : auth?.userProfile?.companyId;
  const userPackageId = auth?.userProfile?.prdId;
  const allowedPermissions = packageAccess(userPackageId);
  const [verificationRequired, setVerificationRequired] = useState({
    open: false,
    setupIntentId: null,
    id: null
  });
  const [messageDialog, setMessageDialog] = useState(false);
  const [verificationDetails, setVerificationDetails] = useState();
  const [verificationLoader, setVerificationLoader] = useState(false);
  const isMobile = useMediaQuery("(max-width:767px)");
  const navigate = useNavigate();
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);
  const { toast } = useToast();
  const ENV = process.env.REACT_APP_CUSTOM_ENV || "dev";

  const formatPrice = (amount, currency, quantity = 1) => {
    if (!amount || !currency) return "";
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currency.toUpperCase(),
    }).format((amount * quantity) / 100);
  };

  const Columns = [
    {
      id: "date",
      numeric: false,
      disablePadding: true,
      label: "Date",
      isSortable: true,
    },
    {
      id: "description",
      numeric: false,
      disablePadding: true,
      label: "Description",
      isSortable: true,
    },
    {
      id: "amounts",
      numeric: false,
      disablePadding: true,
      label: "Amount",
      isSortable: true,
    },
    {
      id: "credit",
      numeric: false,
      disablePadding: true,
      label: "Credit",
      isSortable: true,
    },
    {
      id: "status",
      numeric: false,
      disablePadding: true,
      label: "Status",
      isSortable: true,
    },
    {
      id: "action",
      numeric: false,
      disablePadding: true,
      label: "Action",
      isSortable: true,
    },
  ];

  const formatStorage = (bytes) => {
    if (bytes >= 1 * 1024 * 1024 * 1024 * 1024) {
      return `${Math.floor(bytes / (1024 ** 4))} TB`;
    }
    if (bytes >= 1024 * 1024 * 1024) {
      return `${Math.floor(bytes / (1024 ** 3))} GB`;
    }
    if (bytes >= 1024 * 1024) {
      return `${Math.floor(bytes / (1024 ** 2))} MB`;
    }
    return `${Math.floor(bytes / 1024)} KB`;
  };

  const cmsFeatures = [
    "Full CMS / Webportal Access",
    "Custom Integration",
    "Full Mobile app for Field Teams",
    "Alerts and seamless notifications",
    "Real-time chat with unlimited messaging",
    "Supplies Management",
    "Issues Management",
    "Comprehensive Reporting for your team and your clients",
    `It includes a maximum limit of ${allowedPermissions?.userLimit} users`,
    `It includes a maximum storage limit of ${formatStorage(allowedPermissions?.storageLimits)}`
  ];

  const formatDate = (timestamp) =>
    timestamp ? moment.unix(timestamp).format("MM/DD/YYYY") : "N/A";

  const formatLastDateOfMonth = (timestamp) =>
    timestamp
      ? moment.unix(timestamp).endOf("month").format("MM/DD/YYYY")
      : "N/A";

  const formatStripeAmount = (amount) => {
    return `$${(amount / 100).toFixed(0)}`;
  };

  const BASE_PRICE_MAP = [
    { name: "Standard", amount: 99 },
    { name: "Plus", amount: 249 },
    { name: "Professional", amount: 375 },
    { name: "Standard", amount: 990 },
    { name: "Plus", amount: 2499 },
    { name: "Professional", amount: 3750 },
  ];

  const PRICING_CONFIG = {
    dev: [
        "price_1RY2GjH54HzvHwSd7xIHfw9Z",
        "price_1RY2L2H54HzvHwSdeCNKydVJ",
        "price_1RY2SdH54HzvHwSdE62LQFMq",
        "price_1RYSEYH54HzvHwSdWnZO85Pk",
        "price_1RYSH0H54HzvHwSdPNwhG0Zf",
        "price_1RbFRkH54HzvHwSd8QpK4ZPQ",
      ],
    stage: [
        "price_1Rg4StHG9KfCFcBtk62AyLjl",
        "price_1Rg4VOHG9KfCFcBtUdpounGQ",
        "price_1Rg4YeHG9KfCFcBthKGhErSl",
        "price_1Rg4TIHG9KfCFcBti234fUD6",
        "price_1Rg4VsHG9KfCFcBtOKbt91yg",
        "price_1Rg4ZuHG9KfCFcBtO4Q6Y12k",
      ],  
    prod: [
        "price_1RsdHLHPX5Uwv3eVePGNLRLj",
        "price_1RsdPgHPX5Uwv3eV7k7eyln8",
        "price_1RsdVFHPX5Uwv3eVbavvVBji",
        "price_1RsdLlHPX5Uwv3eV3ozmcddw",
        "price_1RsdQBHPX5Uwv3eVmDc1CW9P",
        "price_1RsdVaHPX5Uwv3eVGScEMH75",
      ],  
  }

  const priceIds = PRICING_CONFIG[ENV];
  const priceMap = {};

  priceIds?.forEach((id, index) => {
    priceMap[id] = BASE_PRICE_MAP[index];
  });

  const { allowedPriceIds } = PRICING_CONFIG[ENV];
  const fetchCompanyList = async () => {
    try {
      commonContext.setLoader(true);

      const [companyResponse, invoiceData, cardsData, verificationData] = await Promise.all([
        new Promise((resolve) => getAllEmployee(resolve)),
        new Promise((resolve) => getInvoice("strip_invoice", resolve)),
        getCustomerPaymentMethods(auth?.userProfile?.customer),
        getPendingPaymentVerificationByUser(auth?.userProfile?.id, 'pending_verification')
      ]);

      setVerificationDetails(verificationData)
      const companyData = companyResponse?.data || [];
      const companyUsers = companyData.filter(
        (item) => item.role === "companyUser" && !item.deleted
      );

      const filteredCompanyUsers =
        auth?.userProfile?.role === "superUser"
          ? companyUsers
          : companyUsers.filter((company) => company?.id === companyId);

      const downloadableStatuses = ["paid", "pending", "canceled"];

      const formattedCompanyData = filteredCompanyUsers?.flatMap((company) => {
        // Get invoices for this customer
        const companyInvoices = invoiceData?.data
          ?.filter((inv) => inv.customer === company.customer)
          ?.sort((a, b) => a.created - b.created); // Oldest to newest

        if (!companyInvoices?.length) return [];

        return companyInvoices?.map((invoice, i, arr) => {
          const line = invoice?.lines?.data?.[0];
          const plan = line?.plan?.name || priceMap[line?.pricing?.price_details?.price]?.name;
          const interval = line?.plan?.interval || "";
          const currentAmount = line?.plan?.amount || 0;
          const billingReason = invoice.billing_reason;
          const metadataComment = invoice?.subscription_details?.metadata?.comment;
          const isPaid = invoice?.status?.toLowerCase() === "paid";

          // Get previous invoice’s plan and amount (if any)
          const prev = arr[i - 1];
          const prevPlan = prev?.lines?.data?.[0]?.plan?.name;
          const prevAmount = prev?.lines?.data?.[0]?.plan?.amount || 0;

          // Build description efficiently
          let description = "";
          if (billingReason === "subscription_update" || billingReason === "subscription_create") {
            if (prevPlan && prevPlan !== plan) {
              description =
                currentAmount > prevAmount
                  ? `Upgraded from ${prevPlan} to ${plan} Plan`
                  : currentAmount < prevAmount
                  ? `Downgraded from ${prevPlan} to ${plan} Plan`
                  : `Changed from ${prevPlan} to ${plan} Plan`;
            } else {
              description = invoice.total  === 0 ? "Started free Trial Plan" : `Started ${plan} Plan`;
            }
          } else if (billingReason === "subscription_cycle") {
            description =
              interval === "year"
                ? `Annual payment for ${plan} Plan`
                : interval === "month"
                ? `Monthly payment for ${plan} Plan`
                : `Recurring payment for ${plan} Plan`;
          }

          if (!description && metadataComment) description = metadataComment;
          if (!description) description = "Subscription invoice";
          const startingBalance = invoice?.starting_balance || 0;

          return {
            ...invoice,
            date: formatDate(invoice.created),
            plan,
            description,
            amounts: invoice.total > 0 ? formatStripeAmount(invoice.total) : 0,
            credit: startingBalance !== 0 ? formatStripeAmount(Math.abs(startingBalance)) : 0,
            status: invoice.collection_method === "send_invoice" ? "Trial" : invoice.status,
            isPaid,
          };
        });
      });
      const paidCompanyInvoices = formattedCompanyData?.filter(item => item.isPaid && item.collection_method !== "send_invoice")?.sort((a, b) => b.finalized_at - a.finalized_at);
      setCompanyData(paidCompanyInvoices);

      const pendingACH = verificationData?.map((item) => ({
        id: item.paymentMethod.id,
        setupIntentId: item.setupIntentId,
        type: "us_bank_account",
        bank_name: item.paymentMethod.us_bank_account.bank_name,
        last4: item.paymentMethod.us_bank_account.last4,
        account_holder_type: item.paymentMethod.us_bank_account.account_holder_type,
        account_type: item.paymentMethod.us_bank_account.account_type,
        status: item.status,
      }));


      const finalResponse = {
        cards: [...cardsData.cards, ...pendingACH],
        defaultPaymentMethodId: cardsData?.defaultPaymentMethodId
      };

      setCardDetails(finalResponse);
      // setCompanyData(formattedCompanyData);
    } catch (err) {
      console.error("Error fetching company list:", err);
    } finally {
      commonContext.setLoader(false);
    }
  };

  useEffect(() => {
    fetchCompanyList();
    // const pricesData = async () => {
    //   const data = await getStripeConfigs();
    //   if (data.success) {
    //     const allPrices = data.data.prices;
    //     const activePrices = allPrices.filter(
    //       (price) => allowedPriceIds?.includes(price.id) && price.active === true
    //     );
    //     setPrices(activePrices);
    //   } else {
    //     console.error(data.error);
    //   }
    // };
    // pricesData();
  }, []);

  const handleDeleteCard = async (id) => {
    await detachPaymentMethod(id);
    await fetchCompanyList();
    toast({
      title: "Payment method removed",
      description: "The payment method has been removed successfully",
      variant: "default",
    });
  };

  const handleMakeDefault = async (paymentMethodId) => {
    try {
      await updateDefaultPaymentMethod(
        paymentMethodId,
        auth?.userProfile?.customer
      );
      toast({
        title: "Card set as default",
        description: "Card set as default successfully.",
      });
      await fetchCompanyList();
    } catch (err) {
      console.error("Error setting default:", err);
      toast({
        title: "Error",
        description: "Failed to update default card.",
        variant: "destructive",
      });
    }
  };

  const handleChangeSubscription = () => {
    navigate("/account/upgrade");
  };

  const handleDownloadInvoicePDF = async (invoice) => {
    try {
      setLoadingInvoiceId(invoice?.id);
      let finalUrl;
      const freshInvoice = await getFreshInvoiceData(invoice?.id);

      if (freshInvoice.payment_intent) {
        const charges = await getChargesData(freshInvoice);
        const url = charges?.receipt_url;
        if (!url) {
          console.error("Receipt URL not found.");
          return;
        }
        const baseUrl = url.split("?")[0];
        finalUrl = `${baseUrl}/pdf?s=ap`;
      } else if (freshInvoice?.invoice_pdf) {
        finalUrl = freshInvoice?.invoice_pdf;
      } else {
        console.error("No valid URL found for invoice download.");
        setLoadingInvoiceId(null);
        return;
      }

      const link = document.createElement("a");
      link.href = finalUrl;
      link.download = `Invoice-${freshInvoice?.number || freshInvoice?.id}.pdf`;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setLoadingInvoiceId(null);
    } catch (error) {
      setLoadingInvoiceId(null);
      console.error("Error downloading invoice PDF:", error);
    }
  };

  const handleClose = () => {
    setDialogOpen(false);
  };

  const handelCancelClose = () => {
    setCancelDialogOpen(false);
  };
  const handleRefundClose = () => {
    setRefundOpen(false);
  };

  const handelUpdateClose = () => {
    setUpdateDialogOpen(false);
  };

  const renderRowCell = (rcellItem, hcellItem, index, rowindex) => {
    switch (hcellItem.id) {
      case "status": 
      return (
       <span
          className={`text-xs font-medium px-2.5 py-0.5 rounded-full capitalize ${
            rcellItem?.status === "paid"
              ? "bg-green-100 text-green-700"
              : rcellItem?.status === "pending"
              ? "bg-yellow-100 text-yellow-700"
              : rcellItem?.status === "canceled"
              ? "bg-red-100 text-red-700"
              : "bg-gray-100 text-gray-700"
          }`}
        >
          {rcellItem?.status}
        </span>
      )
      case "action":
        return (
          <>
         <IconButton
            className="dark:text-white text-[#020817]"
            disabled={loadingInvoiceId === rcellItem.id || Number(rcellItem?.amount) === 0 || rcellItem?.description === "Started free Trial Plan"}
            onClick={() => handleDownloadInvoicePDF(rcellItem)}
          >
            {loadingInvoiceId === rcellItem.id ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              <FileDownloadOutlinedIcon />
            )}
          </IconButton>
          </>
        );

      default:
        return <p>{rcellItem[hcellItem?.id]} </p>;
    }
  };

  const checkRowSearch = (searchTerm, row) => {
    return (
      String(row.companyName)
        .toLowerCase()
        .includes(String(searchTerm).toLowerCase()) ||
      String(row.period)
        .toLowerCase()
        .includes(String(searchTerm).toLowerCase()) ||
      String(row.product)
        .toLowerCase()
        .includes(String(searchTerm).toLowerCase()) ||
      String(row.status)
        .toLowerCase()
        .includes(String(searchTerm).toLowerCase())
    );
  };

  const filteredList =
    searchTerm !== ""
      ? companyData?.filter((item) => checkRowSearch(searchTerm, item))
      : companyData;

  // const handleCancelSubscription = async () => {
  //   setCancelDialogOpen(false);
  //   commonContext.setLoader(true);
  //   try {
  //     const customerId =
  //       auth?.userProfile?.role === "superUser"
  //         ? data?.customer
  //         : filteredList?.[0]?.customer;

  //     if (!customerId) {
  //       console.error("Customer ID not found.");
  //       return;
  //     }
  //     const subscriptionId = auth?.userProfile?.subscriptions?.data?.[0]?.id;
  //     const response = await createStripeLink(customerId, subscriptionId);
  //     commonContext.setLoader(false);
  //     if (response?.url) {
  //       window.location.href = response.url;
  //     } else {
  //       commonContext.setLoader(false);
  //       console.error("Failed to retrieve Stripe URL.");
  //     }
  //   } catch (error) {
  //     commonContext.setLoader(false);
  //     console.error("Error canceling subscription:", error);
  //   }
  // };

  const handleCancelPlan = async () => {
    setCancelDialogOpen(false);
    commonContext.setLoader(true);
    try {
      const customerId =
        auth?.userProfile?.role === "superUser"
          ? data?.customer
          : filteredList?.[0]?.customer;

      if (!customerId) {
        console.error("Customer ID not found.");
        return;
      }
      const subscriptionId =
        auth?.userProfile?.subscriptions?.additionalData?.[0]?.id;
      const response = await createStripeLink(customerId, subscriptionId);
      commonContext.setLoader(false);
      if (response?.url) {
        window.location.href = response.url;
      } else {
        commonContext.setLoader(false);
        console.error("Failed to retrieve Stripe URL.");
      }
    } catch (error) {
      commonContext.setLoader(false);
      console.error("Error canceling subscription:", error);
    }
  };

  const extraLimit = auth?.userProfile?.additionalQuantity * 5;
  const extraLimitInBytes = extraLimit * 1024 ** 3;
  const storageLimit =
    (allowedPermissions?.storageLimits ?? 0) + extraLimitInBytes;

  const subscription = auth?.userProfile?.subscriptionDetails
    ? auth?.userProfile?.subscriptionDetails
    : auth?.userProfile?.subscriptions?.data?.[0];

  const handleCancelSubscription = async () => {
    commonContext.setLoader(true);
    const formData = {
      feedBack: feedBack,
      selectedOption: selectedOption,
    };
    const customerId = auth?.userProfile?.customer;
    const subscriptionId = subscription?.id;
    const res = await CancelStripeSubscription(
      subscriptionId,
      customerId,
      formData
    );
    if (res?.success === true) {
      await delay(4500);
      commonContext.setLoader(false);
      navigate("/dashboard");
      window.location.reload();
    } else {
      commonContext.setLoader(false);
    }
  };

  const handleRefundCancelSubscription = async () => {
    commonContext.setLoader(true);
    setRefundOpen(false);
    const subscriptionId = subscription?.id;
    const formData = {
      feedBack: feedBack,
      selectedOption: selectedOption,
    };
    const res = await CancelStripeSubscription(subscriptionId, formData);
    if (res?.success === true) {
      await delay(4500);
      commonContext.setLoader(false);
      navigate("/dashboard");
      window.location.reload();
    } else {
      commonContext.setLoader(false);
    }
  };

  const handleCloseMessageDialog = async () => {
    setMessageDialog(false); 
    setIsAddDialogOpen(false);
    await fetchCompanyList();
  };


  const sortedCards = [...(cardDetails?.cards || [])]?.sort((a, b) => {
    return a?.id === cardDetails?.defaultPaymentMethodId ? -1 : 1;
  });

  return (
    <>
      <Container>
        <PageTitle
          pageTitle={"Billing"}
          showBreadcrumb={[{ label: "Home" }, { label: "Account" }]}
          BreadCrumbCurrentPageTitle={"Billing"}
          showLastSeen={true}
        />
        {displayStep === 0 && (
          <div className={isMobile ? "" : "ph-15"}>
            <div
              style={{
                maxWidth: isMobile ? "405px" : "1280px",
                margin: isMobile ? "0px auto" : "0px auto",
              }}
            >
              <div
                className={
                  isMobile
                    ? "d-flex flex-direction-column mb-20 p-18"
                    : "d-flex flex-direction-column mb-20"
                }
              >
                <div
                  style={{
                    // color: "#020817",
                    fontSize: "24px",
                    lineHeight: "32px",
                    fontWeight: "700",
                  }}
                  className="text-foreground"
                >
                  Billing
                </div>
                <div
                  className="mt-4"
                  style={{ color: "#6B7280", fontSize: "16px" }}
                >
                  Manage your subscription and payment details
                </div>
              </div>

              <Tabs
                defaultValue="subscription"
                onValueChange={setActiveTab}
                className={styles.tab}
              >
                <div
                  className="d-flex flex-center flex-justify-center dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] bg-[#f1f5f9ff]"
                  style={{
                    overflowX: "auto",
                    paddingBottom: "3px",
                    // backgroundColor: "#f1f5f9ff",
                  }}
                >
                  <div>
                    <TabsTrigger
                      value="subscription"
                      className={`${styles.tabtrigger} ${
                        activeTab === "subscription"
                          ? styles.active
                          : "dark:text-white"
                      }`}
                    >
                      Subscription
                    </TabsTrigger>
                    <TabsTrigger
                      value="payment-methods"
                      className={`${styles.tabtrigger} ${
                        activeTab === "payment-methods"
                          ? styles.active
                          : "dark:text-white"
                      }`}
                    >
                      Payment Methods
                    </TabsTrigger>
                    <TabsTrigger
                      value="history"
                      className={`${styles.tabtrigger} ${
                        activeTab === "history"
                          ? styles.active
                          : "dark:text-white"
                      }`}
                    >
                      Billing History
                    </TabsTrigger>
                  </div>
                </div>

                <TabsContent value="subscription" className="mt-16">
                  <Card
                    className={`${styles.card} dark:text-white dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0`}
                  >
                    <div className={styles.cardHeader}>
                      <div className={styles.cardTitle}>
                        <span>Current Plan</span>
                        <div className={styles.subscriptionStatus}>
                          {subscription?.status === "trialing"
                            ? "Trial Subscription"
                            : subscription?.status?.charAt(0).toUpperCase() +
                              subscription?.status?.slice(1)}
                        </div>
                      </div>
                    </div>

                    <CardContent className={styles.cardContent}>
                      {subscription?.status !== "trialing" && (
                        <div
                          className={`${styles.planDetails} dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`}
                        >
                          <div className={styles.planInfo}>
                            <h3 className="dark:text-white mb-3">
                              {subscription?.plan?.name}
                            </h3>
                            <p>
                              {subscription?.plan?.interval === "month"
                                ? "Monthly Billing"
                                : ""}
                            </p>
                          </div>
                          <div className={styles.planPrice}>
                            <div className="price dark:text-white mb-3">
                              {formatStripeAmount(subscription?.plan?.amount)}
                            </div>
                            <div className="perMonth dark:text-white">
                              per month
                            </div>
                          </div>
                        </div>
                      )}

                      {subscription?.status !== "canceled" &&
                        subscription?.status !== "trialing" && (
                          <div className={styles.billingDetails}>
                            <div
                              className={`${styles.billingCard} dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0`}
                            >
                              <div className={styles.billingInfo}>
                                <div className={styles.billingIcon}>
                                  <CalendarMonthOutlinedIcon
                                    className={`h-5 w-5 text-blue-600 ${styles.icon}`}
                                  />
                                </div>
                                <div className={styles.billingText}>
                                  <p className="label dark:text-white mb-3">
                                    Billing Period
                                  </p>
                                  <p className="value dark:text-white">
                                    {formatDate(subscription?.start_date)} -{" "}
                                    {formatDate(
                                      subscription?.current_period_end
                                    )}
                                  </p>
                                </div>
                              </div>
                            </div>

                            <div
                              className={`${styles.billingCard} dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0`}
                            >
                              <div className={styles.billingInfo}>
                                <div className={styles.billingIcon}>
                                  <AccessTimeOutlinedIcon
                                    className={`h-5 w-5 text-blue-600  ${styles.icon}`}
                                  />
                                </div>
                                <div className={styles.billingText}>
                                  <p className="label dark:text-white mb-3">
                                    Next Payment
                                  </p>
                                  <p className="value dark:text-white">
                                    {formatStripeAmount(
                                      subscription?.plan?.amount
                                    )}{" "}
                                    on{" "}
                                    {formatDate(
                                      subscription?.current_period_end
                                    )}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                      <div>
                        <h4
                          className={`${styles.featuresTitle} dark:text-white`}
                        >
                          Plan Features
                        </h4>
                        <ul className={styles.featuresList}>
                          {cmsFeatures?.map((feature, index) => (
                            <li key={index} className={styles.featureItem}>
                              <div className={styles.featureIcon}>
                                <CheckOutlinedIcon fontSize="small" />
                              </div>
                              <span
                                className={`${styles.featureText} dark:text-white`}
                              >
                                {feature}
                              </span>
                            </li>
                          ))}
                        </ul>

                        <StorageUsage
                          totalStorage={storageLimit}
                          usedStorage={auth?.userProfile?.storage}
                        />
                      </div>

                      {subscription?.status !== "canceled" && (
                        <div className={`${styles.actions} w-100`}>
                          <>
                            {subscription?.status !== "trialing" && (
                              <>
                                {subscription?.plan?.interval === "year" ? (
                                  <Button
                                    variant="outline"
                                    style={{
                                      border:
                                        "1px solid hsl(214.3, 31.8%, 91.4%)",
                                      width: isMobile ? "100%" : "50%",
                                    }}
                                    onClick={() => setDisplayStep(1)}
                                  >
                                    Cancel Subscription & Refund
                                  </Button>
                                ) : (
                                  <Button
                                    variant="outline"
                                    style={{
                                      border:
                                        "1px solid hsl(214.3, 31.8%, 91.4%)",
                                      width: isMobile ? "100%" : "50%",
                                    }}
                                    onClick={() => setDisplayStep(1)}
                                  >
                                    Cancel Subscription
                                  </Button>
                                )}
                              </>
                            )}
                            <Button
                              className="w-100"
                              style={{
                                color: "white",
                                backgroundColor: "#16A34A",
                                width: isMobile
                                  ? "100%"
                                  : subscription?.status === "trialing"
                                  ? "100%"
                                  : "50%",
                                marginTop: isMobile ? "10px" : "",
                              }}
                              onClick={handleChangeSubscription}
                            >
                              Change Plan
                            </Button>
                          </>
                        </div>
                      )}
                      {subscription?.status === "canceled" && (
                        <div
                          className="text-center"
                          style={{ color: "red", fontSize: "16px" }}
                        >
                          {`Your subscription has been cancelled, but you'll continue to have access until ${formatLastDateOfMonth(
                            subscription?.canceled_at
                          )}. After this, your access will be revoked.`}
                        </div>
                      )}
                    </CardContent>
                  </Card>
                </TabsContent>

                <TabsContent value="payment-methods" className="mv-16">
                  <Card
                    className={`${styles.card} p-24 dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0`}
                  >
                    <CardHeader>
                      <CardTitle className="flex items-center justify-between">
                        <span className="dark:text-white">Payment Methods</span>
                        <Dialog
                          open={isAddDialogOpen}
                          onOpenChange={(open) => {
                            setIsAddDialogOpen(open);
                            if (!open) setName("");
                          }}
                        >
                          <DialogTrigger asChild>
                            <Button size="sm" className="bg-[#16A34A]">
                              <Plus className="h-4 w-4 mr-8" /> Add New Method
                            </Button>
                          </DialogTrigger>
                          <DialogContent closeOnOutsideClick={false}>
                            <DialogHeader>
                              <DialogTitle className="dark:text-white">
                                Add Payment Method
                              </DialogTitle>
                              <DialogDescription>
                                Enter your card details to add a new payment
                                method.
                              </DialogDescription>
                            </DialogHeader>
                            <Elements stripe={stripePromise}>
                              <CardForm
                                name={name}
                                setName={setName}
                                setIsAddDialogOpen={setIsAddDialogOpen}
                                fetchCompanyList={fetchCompanyList}
                                messageDialog={messageDialog}
                                setMessageDialog={setMessageDialog}
                              />
                            </Elements>
                          </DialogContent>
                        </Dialog>
                      </CardTitle>
                    </CardHeader>

                    <CardContent className={styles.cardContent}>
                      {sortedCards?.map((item) => {
                        const isDefault =
                          item?.id === cardDetails?.defaultPaymentMethodId;
                        const isCard = item?.type === "card";
                        const isBank =
                          !item?.type || item?.type === "us_bank_account";
                          const needsVerification = (item) => {
                            const status = item?.us_bank_account?.status || item?.status;
                            return !!status && status !== "verified";
                          };
                        const matchData = verificationDetails?.find((itm) => itm?.paymentMethodId === item?.id);
                        return (
                          <div
                            key={item.id}
                            className={`${styles.cardItem} dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0`}
                          >
                            <div className={styles.cardLeft}>
                              <div className={styles.cardIcon}>
                                {isCard ? (
                                  <CreditCardOutlinedIcon
                                    className={styles.icon}
                                  />
                                ) : (
                                  <Landmark className={styles.icon} />
                                )}
                              </div>
                              <div>
                                {isCard && (
                                  <>
                                    <p
                                      className={`${styles.cardBrand} dark:text-white`}
                                    >
                                      {item?.card?.brand?.toUpperCase()} ••••{" "}
                                      {item?.card?.last4}
                                    </p>
                                    <p className={styles.cardExpiry}>
                                      Expires {item?.card?.exp_month}/
                                      {item?.card?.exp_year}
                                    </p>
                                  </>
                                )}

                                {isBank && (
                                  <>
                                    <p
                                      className={`${styles.cardBrand} dark:text-white`}
                                    >
                                      {item?.us_bank_account?.bank_name ||
                                        item?.bank_name}{" "}
                                      ••••{" "}
                                      {item?.us_bank_account?.last4 ||
                                        item?.last4}
                                    </p>
                                    <p className={styles.cardExpiry}>
                                      {item?.us_bank_account?.account_holder_type?.toUpperCase() ||
                                        item?.account_holder_type?.toUpperCase()}{" "}
                                      •{" "}
                                      {item?.us_bank_account?.account_type ||
                                        item?.account_type ||
                                        "Checking"}
                                    </p>
                                  </>
                                )}
                              </div>
                            </div>
                            <div className={styles.cardRight}>
                              {isDefault && (
                                <div className={styles.defaultBadge}>
                                  Default
                                </div>
                              )}
                              {isBank && needsVerification(item) && (
                                  <Button
                                    size="sm"
                                    className="bg-[#16A34A]"
                                    onClick={() =>
                                      setVerificationRequired({
                                        open: true,
                                        setupIntentId:
                                          matchData?.setupIntentId,
                                        id: matchData?.id,
                                      })
                                    }
                                  >
                                    {" "}
                                    Verify Now{" "}
                                  </Button>
                                )}
                              {!isDefault && (
                                <AlertDialog>
                                  <AlertDialogTrigger asChild>
                                    <Button
                                      variant="ghost"
                                      size="sm"
                                      className="text-amber-600 hover:text-amber-800 dark:text-amber-600"
                                      disabled={isBank && needsVerification(item)}
                                    >
                                      Make Default
                                    </Button>
                                  </AlertDialogTrigger>
                                  <AlertDialogContent className="dark:bg-[#1A1F2C]">
                                    <AlertDialogHeader>
                                      <AlertDialogTitle className="dark:text-white">
                                        Set as Default?
                                      </AlertDialogTitle>
                                      <AlertDialogDescription className="dark:text-[#6B7280]">
                                        Are you sure you want to make this your
                                        default payment method?
                                      </AlertDialogDescription>
                                    </AlertDialogHeader>
                                    <AlertDialogFooter>
                                      <AlertDialogCancel>
                                        Cancel
                                      </AlertDialogCancel>
                                      <AlertDialogAction
                                        onClick={() =>
                                          handleMakeDefault(item.id)
                                        }
                                      >
                                        Confirm
                                      </AlertDialogAction>
                                    </AlertDialogFooter>
                                  </AlertDialogContent>
                                </AlertDialog>
                              )}
                              {!isDefault && (
                                <AlertDialog>
                                  <AlertDialogTrigger asChild>
                                    <Button
                                      variant="ghost"
                                      size="sm"
                                      className="text-red-500 hover:text-red-700"
                                    >
                                      <Trash className="h-4 w-4" />
                                    </Button>
                                  </AlertDialogTrigger>
                                  <AlertDialogContent>
                                    <AlertDialogHeader>
                                      <AlertDialogTitle className="dark:text-white">
                                        Remove payment method?
                                      </AlertDialogTitle>
                                      <AlertDialogDescription>
                                        <p className="mt-8 text-amber-600 dark:text-[#6B7280]">
                                          Are you sure you want to remove this
                                          payment method?
                                        </p>
                                      </AlertDialogDescription>
                                    </AlertDialogHeader>
                                    <AlertDialogFooter>
                                      <AlertDialogCancel>
                                        Cancel
                                      </AlertDialogCancel>
                                      <AlertDialogAction
                                        onClick={() =>
                                          handleDeleteCard(item.id)
                                        }
                                      >
                                        Remove
                                      </AlertDialogAction>
                                    </AlertDialogFooter>
                                  </AlertDialogContent>
                                </AlertDialog>
                              )}
                            </div>
                          </div>
                        );
                      })}

                      <div className={styles.noteBox}>
                        <p className={styles.noteTitle}>Important Note</p>
                        <p className={styles.noteText}>
                          Your payment method will be charged automatically on
                          your next billing date. You can update or change your
                          payment method at any time.
                        </p>
                      </div>
                    </CardContent>
                  </Card>
                </TabsContent>

                <TabsContent value="history" className="mb-16">
                  <div
                    className="bg-white dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0 border-2 border-[#e2e8f0]"
                    style={{
                      padding: "20px",
                      margin: "20px",
                      borderRadius: "4px",
                    }}
                  >
                    <div
                      className="dark:text-white text-[#020817]"
                      style={{
                        // color: "#020817",
                        fontSize: "26px",
                        fontWeight: "600",
                        marginBottom: "20px",
                      }}
                    >
                      Billing History
                    </div>
                    <ThemeTable
                      rows={filteredList}
                      headCells={Columns}
                      hidePagination={true}
                      isLoading={isLoading}
                      renderRowCell={renderRowCell}
                    />
                  </div>
                </TabsContent>
              </Tabs>
            </div>
          </div>
        )}

        {displayStep === 1 && (
          <CancelStep1
            setDisplayStep={setDisplayStep}
            data={subscription}
            prices={prices}
          />
        )}
        {displayStep === 2 && (
          <CancelStep2
            setDisplayStep={setDisplayStep}
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
            feedBack={feedBack}
            setFeedBack={setFeedBack}
            handleCancelSubscription={handleCancelSubscription}
          />
        )}
      </Container>
      {/* <CancelSubscription
        open={cancelDialogOpen}
        onConfirm={handleCancelSubscription}
        onCancel={handelCancelClose}
        onClose={handelCancelClose}
      /> */}

      {verificationRequired?.open && (
        <BankAccountVerification
          open={verificationRequired?.open}
          onSuccess={() => {
            setVerificationRequired({
              open: false,
              setupIntentId: null,
              id: null,
            });
            setVerificationLoader(false);
            fetchCompanyList();
          }}
          onClose={() => {
            setVerificationRequired({
              open: false,
              setupIntentId: null,
              id: null,
            });
            setVerificationLoader(false);
          }}
          setupIntentId={verificationRequired?.setupIntentId}
          customerId={auth?.userProfile?.customer}
          verificationLoader={verificationLoader}
          setVerificationLoader={setVerificationLoader}
          id={verificationRequired?.id}
        />
      )}

      <RefundSubscriptionAmount
        open={refundOpen}
        onConfirm={handleRefundCancelSubscription}
        onCancel={handleRefundClose}
        onClose={handleRefundClose}
        data={subscription}
      />

      {messageDialog && (
        <MuiDialog open={messageDialog}>
          <div className="d-flex flex-space-between flex-center dark:bg-[#1A1F2C]">
            <MuiTypography
              variant="body"
              className="mt-25 dialogTitle dark:text-white"
            >
              Bank Account Verification Pending
            </MuiTypography>
          </div>

          <MuiDivider className="mt-10" />

          <MuiDialogContent className="mb-10 dark:bg-[#1A1F2C]" style={{ fontWeight: "600" }}>
            <div
              style={{
                lineHeight: "22px",
                fontSize: "16px",
                marginTop: "16px",
              }}
              className="text-[#64748B] dark:text-[#F1F5F9]"
            >
              To complete the verification process, please follow the steps
              below:
              <br />
              <br />
              • Stripe will send two small micro-deposits (small amounts) to
              your bank account.
              <br />
              • These deposits typically arrive within 2–3 business days.
              <br />
              • Once you receive the deposits sent on behalf of ProTeams/Stripe
              in your bank statement, note the exact amounts.
              <br />
              • Return to this screen and enter both deposit amounts to verify
              your bank account.
              <br />
              <br />
              After your verification is successfully completed, your bank
              account will be fully functional.
            </div>
          </MuiDialogContent>
            <MuiDialogActions className="mt-20 mb-15">
              <Button
                variant="contained"
                style={{
                  backgroundColor: "green",
                  color: "white",
                  borderRadius: "5px",
                  padding: "8px 16px",
                }}
                onClick={() => handleCloseMessageDialog()}
              >
                Close
              </Button>
          </MuiDialogActions>
        </MuiDialog>
      )}
    </>
  );
};
export default CompanySubscription;
